/*
 * This file is created by Vatsaly Patel
 * Note: If you are editing anything, please let me know - or do comment [it's compulsory]
 */

import React, { useEffect, useCallback, useState } from "react";
import { useFormik } from "formik";
import DefaultPicture from "../../assets/images/default-picture.png";
import Label from "../../components/label";
import { getUserProfile } from "../../apiRoutes";
import ICMaskInputDisplay from "../../components/maskInputDisplay";

const MyProfileForm = props => {
  const [userData, setUserData] = useState(null);

  const formik = useFormik({
    initialValues: {
      name: userData ? userData.firstName + " " + userData.lastName : "-",
      abn: userData ? userData.ABN : "-",
      dob: userData ? userData.dateOfBirth : "-",
      gender: userData ? userData.gender : "-",
      email: userData ? userData.email : "-",
      mobileNo: userData ? userData.phoneNumber.replace(/\s/g, "") : "",
      address: userData
        ? (userData.address.unitNumber
            ? userData.address.unitNumber + "/"
            : "") +
          (userData.address.streetNumber ? userData.address.streetNumber : "") +
          " " +
          (userData.address.streetName ? userData.address.streetName : "") +
          ", " +
          (userData.address.suburb ? userData.address.suburb : "") +
          " " +
          (userData.address.state ? userData.address.state : "") +
          " " +
          (userData.address.postCode ? userData.address.postCode : "")
        : "-",
      ec1Name:
        userData && userData.ec1 && userData.ec1.name ? userData.ec1.name : "-",
      ec1ContactNo:
        userData && userData.ec1 && userData.ec1.contact
          ? userData.ec1.contact.replace(/\s/g, "")
          : "",
      ec2Name:
        userData && userData.ec2 && userData.ec2.name ? userData.ec2.name : "-",
      ec2ContactNo:
        userData && userData.ec2 && userData.ec2.contact
          ? userData.ec2.contact.replace(/\s/g, "")
          : "",
      profilePic:
        userData && userData.profilePic ? userData.profilePic.original : ""
    },
    enableReinitialize: true
  });

  const getProfileData = useCallback(() => {
    let apiCallParam = {
      reqType: "GET",
      reqURL: getUserProfile,
      dataObj: {},
      params: {},
      headers: {},
      successCallback: res => {
        setUserData(res.data.data[0]);
      },
      failureCallback: err => {
        //console.log("Something went wrong. Please try again ", err);
      },
      showPopUp: false
    };
    props.makeAPICall(apiCallParam);
  });

  useEffect(() => {
    getProfileData();
  }, []);

  return (
    <form className="w-100" onSubmit={formik.handleSubmit}>
      <div className="card p-4 custom-card">
        <div className="row">
          <div className="col-sm-6">
            <div className="row mt-2">
              <div className="col-sm-12 mb-3">
                <Label
                  className="w-100 secondary-font m-0"
                  title="Basic Information"
                />
              </div>

              <div className="col-sm-6">
                <Label title="Your Name:" className="gray small" />
              </div>
              <div className="col-sm-6 pt-1">
                <Label title={formik.values.name} className="gray small" />
              </div>
            </div>
            <div className="row mt-2">
              <div className="col-sm-6">
                <Label title="ABN:" className="gray small" />
              </div>
              <div className="col-sm-6 pt-1">
                <ICMaskInputDisplay
                  mask="99 999 999 999"
                  value={formik.values.abn}
                  className="gray small"
                />
              </div>
            </div>
            <div className="row mt-2">
              <div className="col-sm-6">
                <Label title="Date of Birth:" className="gray small" />
              </div>
              <div className="col-sm-6 pt-1">
                <Label title={formik.values.dob} className="gray small" />
              </div>
            </div>

            <div className="row mt-2">
              <div className="col-sm-6">
                <Label title="Gender:" className="gray small" />
              </div>
              <div className="col-sm-6 pt-1">
                <Label title={formik.values.gender} className="gray small" />
              </div>
            </div>
          </div>
          <div className="col-sm-6 ic-doctor-pic">
            <img
              src={
                formik.values.profilePic && formik.values.profilePic !== ""
                  ? formik.values.profilePic
                  : DefaultPicture
              }
              alt="ic-doctor-profile"
              className="rounded-circle"
            />
          </div>
        </div>
      </div>

      <div className="card p-4 mt-2 custom-card">
        <div className="row mt-2">
          <div className="col-sm-12 mb-3">
            <Label
              className="w-100 secondary-font m-0"
              title="Contact Information"
            />
          </div>

          <div className="col-sm-3">
            <Label title="Email:" className="gray small" />
          </div>
          <div className="col-sm-5 pt-1">
            <Label title={formik.values.email} className="gray small" />
          </div>
        </div>
        <div className="row mt-2">
          <div className="col-sm-3">
            <Label title="Mobile Number:" className="gray small" />
          </div>
          <div className="col-sm-5 pt-1">
            <ICMaskInputDisplay
              mask="9999 999 999"
              value={formik.values.mobileNo}
              className="gray small"
            />
          </div>
        </div>
        <div className="row mt-2">
          <div className="col-sm-3">
            <Label title="Address:" className="gray small" />
          </div>
          <div className="col-sm-5 pt-1">
            <Label title={formik.values.address} className="gray small" />
          </div>
        </div>
      </div>

      <div className="card p-4 mt-2 custom-card">
        <div className="row mt-2">
          <div className="col-sm-12 mb-3">
            <Label
              className="w-100 secondary-font m-0"
              title="Emergency Contact 1"
            />
          </div>

          <div className="col-sm-3">
            <Label title="Name:" className="gray small" />
          </div>
          <div className="col-sm-5 pt-1">
            <Label title={formik.values.ec1Name} className="gray small" />
          </div>
        </div>
        <div className="row mt-2">
          <div className="col-sm-3">
            <Label title="Contact Number:" className="gray small" />
          </div>
          <div className="col-sm-5 pt-1">
            <ICMaskInputDisplay
              mask="9999 999 999"
              value={formik.values.ec1ContactNo}
              className="gray small"
            />
          </div>
        </div>
      </div>

      <div className="card p-4 mt-2 custom-card">
        <div className="row mt-2">
          <div className="col-sm-12 mb-3">
            <Label
              className="w-100 secondary-font m-0"
              title="Emergency Contact 2"
            />
          </div>

          <div className="col-sm-3">
            <Label title="Name:" className="gray small" />
          </div>
          <div className="col-sm-5 pt-1">
            <Label title={formik.values.ec2Name} className="gray small" />
          </div>
        </div>
        <div className="row mt-2">
          <div className="col-sm-3">
            <Label title="Contact Number:" className="gray small" />
          </div>
          <div className="col-sm-5 pt-1">
            <ICMaskInputDisplay
              mask="9999 999 999"
              value={formik.values.ec2ContactNo}
              className="gray small"
            />
          </div>
        </div>
      </div>
    </form>
  );
};

export default MyProfileForm;
